//////////////////////////////////////////////////////////////////////
//
//  09/26/18
//  src/containers/CityBiz.js
//
//  This file is the top level CityBiz javascript file.
//
//  Redux
//  1 - There is 1 global state object that manages the state for your entire
//      application.
//  2 - The only way to modify the state is through emitting an action, which
//      is an object that describes what should change.  Action Creators are
//      the functions that are 'dispatch'ed to emit a change - all they do is
//      'return' an action.
//  3 - When an action is 'dispatch'ed, a 'Reducer' is the function that actually
//      changes the state appropriate to that action - or returns the existing
//      state if the action is not applicable to that reducer.
//  4 - 'Reducer's are 'pure functions'. They should not have any side-effects
//      nor mutate the state - they must return a modified copy.
//  5 - Individual reducers are combined into a single 'rootReducer' to create
//      the discrete properties of the state.
//  6 - The 'Store' is the thing that brings it all together: it represents the
//      state using the 'rootReducer', any middleware (Thunk in our case), and
//      allows you to actually 'dispatch' actions.
//  7 - For using Redux in React, the '<Provider /> component wraps the entire
//      application and passes the 'store' down to all children.
//
//  Note: In Redux, all reducers get called regardless of the action, so inside each
//  you have to return the original 'state' if the action is not applicable.
//
//  Note: By default, Redux action creators don't support asynchronous actions like
//  fetching data, so here's where we utilise Redux Thunk.  Thunk allows you to 
//  write action creators that return a function instead of an action.
//
//  'connect' is what allows us to connect a component to Redux's store.
//
//  If a component is not rendered inside of a Route component, you can use
//  'withRouter' to get route props (match, location, history).
//
//  With a Route you can pass additional props with either component or render (but not both).
//
//  After the component's class definition, map Redux's state and dispatching the 
//  action creator to props.
//
//  How to 'build' a react app to a sub-directory:
//  https://medium.com/@svinkle/how-to-deploy-a-react-app-to-a-subdirectory-f694d46427c1
//
//  1) Set a property called 'homepage' in your package.json file: 
//     (you can do once and leave in for local testing)
//      "homepage" : "https://myapp.com/directory-name",
//
//  3) Update the routes by using the 'process.env.PUBLIC_URL' variable: (done)
//      <Route path={ `${ process.env.PUBLIC_URL }/` } component={ Home } />
//
//  4) Update the links made to different pages:  (done)
//      <Link to={ `${ process.env.PUBLIC_URL }/page-path` }>Blaugh Blaugh Blaugh</Link>
//
//  Leave this with '' for both local and production:   (and use 'npm start' and port: localhost:3000) 
//    <Router basename={ '' }>
//
//  To build:  "npm run build"
//

import React, { Component } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { configureStore } from "../store";
import Navbar from "./Navbar";
import Main   from "./Main";
import './CityBiz.css';

const store = configureStore();

class CityBiz extends Component {
  render() {
    return (
      <Provider store={ store }>
        <Router>
          <div className="CityBiz">
            <Navbar />
            <Main />
          </div>
        </Router>
      </Provider>
    );
  }
}

export default CityBiz;



// WEBPACK FOOTER //
// ./src/containers/CityBiz.js